import { change } from 'redux-form'

export default ({ form, field, value }) => change(form, field, value)
